<template>
  <div>
    <page-header
      :actions="pageHeaderActionsConfig"
      :page="pageHeaderConfig"
      right-side-class="col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
    />
    <board :details="invoiceDetailsBoard" />
    <div class="mt-4">
      <section-title has-line title="Historial de Plan Enmendado" />
      <div
        v-for="(item, index) in history"
        :key="`history-item-${index}`"
        class="row bg-secondary-3 rounded ml-2 mr-0 p-3 mb-2"
      >
        <div class="col border-right d-flex align-items-center">
          <div class="color-black font-16 font-weight-bold">
            {{ item.statusName }}
          </div>
        </div>
        <div class="col">
          <div class="color-gray-6 font-14 font-weight-normal">Fecha:</div>
          <div class="color-black font-weight-normal">
            {{ item.date | date }}
          </div>
        </div>
        <div
          class="col-12 col-md-8 mt-3 mt-md-0 d-flex justify-content-end align-items-center"
        >
          <action-button
            class="outline-success px-2"
            i="fas fa-file-search"
            text="Ver Plan"
            variant="outline-success"
            @click="showPlan(item.id, item.academicYearId, index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import { getInterventionPlanHistory } from '@/modules/referralManagement/api';
import { getStudentReferralAdmision } from '@/modules/shared/studentreferral.api';

export default {
  name: 'AmendedPlanHistory',
  components: {
    PageHeader,
    Board,
    SectionTitle,
    ActionButton,
  },
  data() {
    return {
      history: [],
      admissionInfo: {},
      from: 'search',
      fromData: {
        reload: true,
      },
    };
  },
  computed: {
    interventionPlanId() {
      return Number(this.$route.params.interventionPlanId);
    },
    admissionId() {
      return Number(this.$route.params.admissionId);
    },
    pageHeaderConfig() {
      return {
        icon: 'fas fa-user-tie',
        title: 'Historial de Plan Enmendado',
        routes: [
          'Proveedor',
          'Manejo de Referido ',
          'Añadir plan de intervención',
          'Historial de Plan Enmendado',
        ],
      };
    },
    pageHeaderActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () =>
            this.$router.push({
              name: this.from,
              params: this.fromData,
            }),
        },
      ];
    },
    invoiceDetailsBoard() {
      return [
        [
          {
            label: 'SIE:',
            icon: 'fas fa-address-book',
            data: this.admissionInfo.studentSieId,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Estudiante:',
            icon: 'fas fa-address-book',
            data: this.admissionInfo.fullName,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Edad:',
            icon: 'fas fa-calendar-edit',
            data: `${this.admissionInfo.studentAge} años`,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Impedimento:',
            icon: 'fas fa-ballot-check',
            data: this.admissionInfo.impediment,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Región:',
            icon: 'fas fa-map-marker-alt',
            data: this.admissionInfo.region,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Municipio:',
            icon: 'fas fa-map-marker-alt',
            data: this.admissionInfo.municipality,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Código-Escuela:',
            icon: 'fas fa-graduation-cap',
            data: this.admissionInfo.school,
            cols: 'col-12 col-md-3',
          },
        ],
        [
          {
            label: 'Nombre de Especialista:',
            data: this.admissionInfo.admissionSpecialist,
            cols: 'col-4 col-sm col-12 mt-3',
          },
          {
            label: 'Tipo de Servicio:',
            data: this.admissionInfo.disciplineName,
            cols: 'col-4 col-sm col-12 mt-3',
          },
          {
            label: 'Modalidad:',
            data: this.admissionInfo.modalityTypeName,
            cols: 'col-4 col-sm col-12 mt-3',
          },
          {
            label: 'Frecuencia:',
            data: this.admissionInfo.frequency,
            cols: 'col-4 col-sm col-12 mt-3',
          },
          {
            label: 'Duración:',
            data: this.admissionInfo.duration,
            cols: 'col-4 col-sm col-12 mt-3',
          },
        ],
      ];
    },
  },
  async created() {
    await Promise.all([this.getAdmissionInfo(), this.getInterventionHistory()]);
  },
  mounted() {
    if (this.$route.params.from) {
      this.from = this.$route.params.from;
      this.fromData = this.$route.params.fromData;
    }
  },
  methods: {
    async getAdmissionInfo() {
      const { data } = await getStudentReferralAdmision(this.admissionId);
      this.admissionInfo = { ...data };
    },
    async getInterventionHistory() {
      const { data } = await getInterventionPlanHistory(
        this.interventionPlanId
      );
      if (data?.length) {
        this.history = data.map((h) => ({
          ...h,
          statusName: h.isAmendment ? 'Enmendado' : 'Sometido',
        }));
      }
    },
    showPlan(interventionPlanId, academicYearId, index) {
      const isLastPlan = index === 0;
      const params = {
        admissionId: this.admissionId,
        academicYearId: academicYearId,
        interventionPlanId: interventionPlanId,
        from: 'amendedPlanHistory',
        fromData: this.fromData,
      };
      if (!isLastPlan) {
        params.onlyShowPlan = Number(true);
      }
      this.$router.push({
        name: 'interventionPlan',
        params,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .btn-view__extended {
  background: transparent !important;
  &:hover {
    color: #2db782 !important;
  }
}
::v-deep.intervention-plan-continer {
  .mobile-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row;
    flex-wrap: wrap;
  }
}
</style>
